import React from "react";
import { SITE } from "../config/siteConfig";
import { Layout } from "../components/Layout";
import useSeo from "../utils/seo";

export function NotFound() {
  useSeo({
    title: "Page non trouvée",
    description: "Cette page n'existe pas.",
    path: window.location.pathname,
    noindex: true,
  });
  return (
    <Layout>
      <article className="wrap text-page">
        <h1>Page non trouvée</h1>
        <p>La page demandée n'existe pas ou a été déplacée.</p>
        <p>
          <a href="/">Retour à l'accueil de {SITE.brandName}</a>
        </p>
      </article>
    </Layout>
  );
}
